if (!customElements.get('mojokoe-creator-how')) {
  customElements.define('mojokoe-creator-how', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.button = this.querySelector('button');
      this.button?.addEventListener('click', () => this.activate(), { signal: this.controller.signal });
      if (this.button) this.button.disabled = false;
    }

    activate() {
      if (this.video) return;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const src = mobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (!src) return;
      this.dataset.format = mobile ? 'mobile' : 'desktop';
      const video = document.createElement('video');
      video.className = 'mojo-creator-how__video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      video.crossOrigin = 'anonymous';
      video.setAttribute('aria-label', this.dataset.label);
      video.poster = mobile ? this.dataset.mobilePoster : this.dataset.desktopPoster;
      for (const language of ['id', 'en']) {
        const track = document.createElement('track');
        track.kind = 'subtitles';
        track.srclang = language;
        track.label = language === 'en' ? 'English' : 'Indonesia';
        track.src = language === 'en' ? this.dataset.captions : this.dataset.captionsId;
        video.append(track);
      }
      const captionsOff = () => {
        for (const track of video.textTracks) track.mode = 'disabled';
      };
      captionsOff();
      video.addEventListener('loadedmetadata', captionsOff, { once: true, signal: this.controller.signal });
      video.src = src;
      this.video = video;
      this.querySelector('[data-how-frame]').append(video);
      this.dataset.active = 'true';
      this.button.hidden = true;
      this.querySelector('picture').hidden = true;
      const error = this.querySelector('[data-how-error]');
      error.querySelector('a').href = src;
      video.addEventListener('error', () => { error.hidden = false; }, { signal: this.controller.signal });
      video.addEventListener('playing', () => { error.hidden = true; }, { signal: this.controller.signal });
      video.focus();
      video.play().catch(() => {});
    }

    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
